<script setup>
import { useI18n } from "vue-i18n";
const { locale } = useI18n();

import axios from "axios";
import { onMounted, ref } from "vue";

const apps_banner = ref({});

async function getAppsBanner() {
    try {
        const res = await axios.get("/apps-banner-data");
        apps_banner.value = res.data || {};
    } catch (error) {
        console.error("Error fetching :", error);
    }
}

onMounted(() => {
    getAppsBanner();
});
</script>
<template>
    <section class="text-gray-600" v-if="apps_banner?.status == true">
        <div
            class="container 2xl:px-56 xl:px-16 lg:pt-4 sm:pt-8 mx-auto lg:pb-4"
        >
            <div class="pb-6 wow animate__animated animate__fadeInLeft">
                <h2
                    class="text-center text-black leading-tight mx-auto font-roboto title-font xl:text-[44px] lg:text-[36px] sm:text-[28px] text-xl lg:mt-4 mb-2"
                >
                    {{
                        locale === "BN"
                            ? apps_banner?.bn_heading
                            : apps_banner?.heading
                    }}
                </h2>
                <h3
                    class="text-center text-black leading-tight mx-auto font-roboto title-font xl:text-2xl lg:text-xl sm:text-lg text-base mb-4"
                >
                    {{
                        locale === "BN"
                            ? apps_banner?.bn_sub_heading
                            : apps_banner?.sub_heading
                    }}
                </h3>
                <div
                    class="mx-auto border-[3.5px] border-transparent border-t-[#1cbed1] w-36"
                ></div>
            </div>
            <div class="flex flex-wrap">
                <div
                    class="lg:w-1/2 w-full md:mx-auto lg:pt-4 lg:pl-32 bg-white wow animate__animated animate__fadeInRight"
                >
                    <div
                        class="h-full w-full mx-auto justify-center flex items-center"
                    >
                        <VLazyImage
                            :src="apps_banner?.app_image"
                            alt="apps-image"
                            class="xl:h-[540px] xl:w-[280px] h-[410px] w-[220px] object-cover object-center inline-block bg-white"
                        />
                    </div>
                </div>
                <div
                    class="lg:w-1/2 w-full lg:mb-0 p-4 lg:mt-14 mt-4 wow animate__animated animate__fadeInLeft"
                >
                    <div class="lg:mb-10 mb-4">
                        <div class="flex flex-wrap">
                            <div
                                class="xl:w-36 w-24 xl:h-36 h-24 mr-4 border-gray-400 border-2 p-1"
                            >
                                <VLazyImage
                                    :src="apps_banner?.apk_qr_image"
                                    alt="android-qr-code-image"
                                    width="144"
                                    height="144"
                                    class="mb-2 rounded-lg"
                                />
                            </div>

                            <div>
                                <VLazyImage
                                    :src="apps_banner?.google_play_image"
                                    class="w-full xl:h-24 h-16 barcode-icon"
                                    alt="google-play-image"
                                />
                                <a
                                    :href="apps_banner?.apk_download_link"
                                    class="border bg-[#F9B63C] hover:bg-primary hover:text-white rounded-md transition duration-300 flex justify-center items-center py-1 lg:px-3 px-2 tracking-wider font-bold text-black xl:text-2xl text-base text-center"
                                    target="__blank"
                                    >{{ $t("common.download_now") }}</a
                                >
                            </div>
                        </div>
                    </div>

                    <div>
                        <span
                            class="border bg-[#F9B63C] hover:bg- rounded-md transition duration-300 justify-center items-center py-1 px-3 tracking-wider font-bold text-black xl:text-2xl text-base text-center"
                        >
                            {{
                                locale === "BN"
                                    ? apps_banner?.bn_label_one
                                    : apps_banner?.label_one
                            }}
                        </span>
                        <h3
                            class="mt-2 text-black font-semibold 2xl:text-6xl xl:text-6xl lg:text-[36px] text-[22px] leading-tight"
                        >
                            {{
                                locale === "BN"
                                    ? apps_banner?.bn_label_two
                                    : apps_banner?.label_two
                            }}
                        </h3>

                        <h3
                            class="mb-2 text-black font-medium 2xl:text-[45px] xl:text-[40px] lg:text-[36px] text-[18px] leading-tight"
                        >
                            {{
                                locale === "BN"
                                    ? apps_banner?.bn_label_three
                                    : apps_banner?.label_three
                            }}
                        </h3>
                        <span
                            class="mt-4 border bg-[#F9B63C] hover:bg- rounded-md transition duration-300 justify-center items-center py-1 px-6 tracking-wider font-bold text-white xl:text-4xl text-base text-center"
                        >
                            {{
                                locale === "BN"
                                    ? apps_banner?.bn_label_four
                                    : apps_banner?.label_four
                            }}
                        </span>

                        <p
                            class="sm:mt-3 mt-2 font-semibold text-black sm:text-2xl text-base leading-relaxed"
                        >
                            {{
                                locale === "BN"
                                    ? apps_banner?.bn_label_five
                                    : apps_banner?.label_five
                            }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped></style>
